import { Component, Input, OnChanges, OnInit, SimpleChange } from "@angular/core";
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import { TarefasContratoSccService } from "./tarefas-contrato-scc.service";
import { BnLoadingService, MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Movi, EVENTO_SCC, Sald, Endi } from "src/app/model/scc.model";
import { ModalidadeService } from "src/app/shared/services/modalidade.service";
import { FileUtilsService } from "src/app/shared/file-utils.service";
import { Clipboard } from '@angular/cdk/clipboard';
import { PreloadAllModules } from "@angular/router";


@Component({
    selector: "app-contrato-de-repasse",
    templateUrl: "./tarefas-contrato-scc.component.html",
    styleUrls: ["./tarefas-contrato-scc.component.scss"],
    standalone: false
})
export class TarefasContratoSccComponent implements OnInit, OnChanges {
  modalidade$ = this.modalidadeService.modalidadeTitulo$;
  public idSistema1: number;
  public idSistema2: number;
  public idSistema3: number;
  public numeroContrato1: number;
  public numeroContrato2: number;
  public numeroContrato3: number;
  public cnpjAgenteFinanceiro: string;
  public ideEventoScc: number;
  public valorEmReais1: number;
  public valorEmReais2: number;
  public dataMovimento1: Date;
  public dataMovimento2: Date;
  public dataRegistro: Date;
  public emInclusao = true;
  public controleMCF: boolean = false; //SCC ou MCF
  private isAgente: boolean;
  private cnpjUsuario: string;
  private siglaModalidade: string; // FGI PEAC, etc.

  private nomeLoteMovisCsv: string;
  private loteMovisCsv: string;
  private loteEnviado: boolean;

  public modalidadeGarantia: string;

  private eventosScc = EVENTO_SCC;
  private eventosFiltrados;

  private movisConsultados: Movi[];
  private exportacao: any;

  constructor(
    private tarefasContratoSccService: TarefasContratoSccService,
    private alertService: BnAlertsService,

    private messageService: MessageChannelService,

    private modalidadeService: ModalidadeService,
    private fileUtils: FileUtilsService,
    private loadingService: BnLoadingService
  ) { }

  ngOnInit(): void {
    this.movisConsultados = [];
    this.modalidadeService.modalidade$.subscribe((mod) => {
      this.modalidadeGarantia = mod;
      for (let modalidade of this.modalidadeService.getModalidades()) {
        if (modalidade.sigla == mod) {
          this.siglaModalidade = modalidade.sigla;
          this.filtrarEventos(this.idSistema3);
        }
      }
    })
  }

  ngOnChanges() {
    this.filtrarEventos(this.idSistema3);
    this.movisConsultados = [];
  }
  
  public numeroContratoLength() {
    if (this.numeroContrato1 != null) {
      return this.numeroContrato1.toString().length
    }
  }
  
  public calculaDvContrato() {
    if (this.numeroContratoLength() == 10) {
      this.tarefasContratoSccService.calcularDigitoVerificador(this.numeroContrato1).subscribe(res => {
        this.numeroContrato1 = res
        this.alertService.alertaSucesso("Dígito verificador gerado automaticamente","");
      })
    } 
  }

  public limparContrato(){
    this.numeroContrato1 = null;
  }

  public incluirContrato() {
    if (
      this.idSistema1 == null ||
      this.numeroContrato1 == null ||
      this.cnpjAgenteFinanceiro == null
    ) {
      this.alertService.alertaErro(
        "Erro",
        "Preencha todos os campos para criar"
      );
    } else {
      this.loadingService.bloqueiaTela();
      this.tarefasContratoSccService
        .incluirContrato(
          this.idSistema1,
          this.numeroContrato1,
          this.cnpjAgenteFinanceiro,
          this.controleMCF
        )
        .subscribe(() => {
          const controleMCFstr = this.controleMCF ? "MCF" : "SCC"
          this.messageService.addMessage({
            title: "Sucesso",
            type: "CRUD_OPERATION",
            level: messageLevel.SUCCESS,
            message: `Contrato incluído com sucesso no RCC para o CNPJ: ${this.cnpjAgenteFinanceiro} e tipo de controle ${controleMCFstr}.`,
          });
          this.loadingService.liberaTela();
        }, (error) => { this.loadingService.liberaTela(); });
    }
  }

  public simularProCdd() {
    if (
      this.idSistema1 == null ||
      this.numeroContrato1 == null
    ) {
      this.loadingService.bloqueiaTela();
      this.alertService.alertaErro(
        "Erro",
        "Preencha sistema e contrato para simular"
      );
    } else {
      this.loadingService.bloqueiaTela();
      this.tarefasContratoSccService
        .simularProCdd(
          this.idSistema1,
          this.numeroContrato1
        )
        .subscribe(() => {
          this.messageService.addMessage({
            title: "Sucesso",
            type: "CRUD_OPERATION",
            level: messageLevel.SUCCESS,
            message: "Existencia de Pro-CDD configurada para o contrato.",
          });
          this.loadingService.liberaTela();
        }, (error) => { this.loadingService.liberaTela(); });
    }
  }

  public incluirSaldoDePrincipal() {
    if (
      this.idSistema2 == null ||
      this.numeroContrato2 == null ||
      this.dataMovimento1 == null
    ) {
      this.alertService.alertaErro(
        "Erro",
        "Preencha todos os campos para criar"
      );
    } else {
      let saldo = new Sald();
      saldo.sistemaCobranca = this.idSistema2;
      saldo.contratoCobranca = this.numeroContrato2;
      saldo.dataCompetencia = this.dataMovimento1;
      saldo.valorEmUnidadeMonetaria = this.valorEmReais1;

      this.tarefasContratoSccService
        .incluirSaldoDePrincipal(this.idSistema2, this.numeroContrato2, saldo)
        .subscribe(() => {
          this.messageService.addMessage({
            title: "Sucesso",
            type: "CRUD_OPERATION",
            level: messageLevel.SUCCESS,
            message: "Saldo incluído com sucesso no RCC.",
          });
        });
    }
  }

  public incluirMovimento() {
    if (
      this.idSistema3 == null ||
      this.numeroContrato3 == null ||
      this.dataMovimento2 == null ||
      this.ideEventoScc == null ||
      this.valorEmReais2 == null 
    ) {
      this.alertService.alertaErro(
        "Erro",
        "Preencha todos os campos para criar"
      );
    } else {
      let movi = new Movi();
      movi.ideEventoScc = this.ideEventoScc;
      movi.dataCompetencia = this.dataMovimento2;
      movi.dataPagamento = this.dataMovimento2;
      movi.dataRegistro = new Date();
      movi.valorEmReais = this.valorEmReais2;
      movi.valorEmUnidadeMonetaria = this.valorEmReais2;

      this.dataRegistro = new Date();

      this.tarefasContratoSccService
        .incluirMovimento(this.idSistema3, this.numeroContrato3, movi)
        .subscribe(() => {
          this.messageService.addMessage({
            title: "Sucesso",
            type: "CRUD_OPERATION",
            level: messageLevel.SUCCESS,
            message: "MOVI incluído com sucesso no RCC.",
          });
        });
    }
  }

  public incluirLoteMovimentos() {
    this.loteEnviado = true;
    this.loadingService.liberaTela()
    this.tarefasContratoSccService.incluirMovimentosEmLote(this.loteMovisCsv).subscribe((qtdeMovisIncluidos: any) => {
      if (qtdeMovisIncluidos) {
        this.messageService.addMessage({
          title: "INFO",
          type: "CRUD_OPERATION",
          level: messageLevel.SUCCESS,
          message: "MOVIs incluídos com sucesso no RCC. Total de MOVIs incluídos: " + qtdeMovisIncluidos + ". Usar a tarefa de consulta para verificar.",
        });
      }
      this.loadingService.liberaTela();
    },
      (error) => {
        this.loadingService.liberaTela();
      });


    this.loteEnviado = false;
    this.nomeLoteMovisCsv = undefined;
    this.loteMovisCsv = undefined;
  }

  public consultarContrato() {
    if (this.idSistema1 == null || this.numeroContrato1 == null) {
      this.alertService.alertaErro(
        "Erro",
        "Para consultar, preencha os campos:  Sistema e Contrato."
      );
    } else {
      console.log("TESTE: " + this.numeroContrato1)
      this.tarefasContratoSccService
        .consultarContrato(this.idSistema1, this.numeroContrato1)
        .subscribe((resp: Endi) => {
          if (resp) {
            this.messageService.addMessage({
              title: "INFO",
              type: "CRUD_OPERATION",
              level: messageLevel.SUCCESS,
              message: "Este contrato já existe no RCC.",
            });
          } else {
            this.messageService.addMessage({
              type: "CRUD_OPERATION",
              level: messageLevel.WARNING,
              message: "Este contrato não existe no RCC.",
            });
          }
        });

    }
  }

  public consultarSaldoDePrincipal() {
    if (this.idSistema2 == null || this.numeroContrato2 == null) {
      this.alertService.alertaErro(
        "Erro",
        "Para consultar, preencha os campos:  Sistema e Contrato."
      );
    } else {
      this.tarefasContratoSccService
        .consultarSaldoDePrincipal(this.idSistema2, this.numeroContrato2)
        .subscribe((saldo: Sald) => {
          if (saldo && saldo.dataCompetencia) {
            this.messageService.addMessage({
              title: "",
              type: "CRUD_OPERATION",
              level: messageLevel.SUCCESS,
              message: "Já existe saldo de principal para este contrato.",
            });
          } else {
            this.messageService.addMessage({
              title: "INFO",
              type: "CRUD_OPERATION",
              level: messageLevel.WARNING,
              message: "Não existe saldo de principal para este contrato.",
            });
          }
        });
    }
  }

  public consultarMovimento() {
    this.movisConsultados = [];

    if (this.idSistema3 == null || this.numeroContrato3 == null) {
      this.alertService.alertaErro(
        "Erro",
        "Para consultar, preencha os campos:  Sistema e Contrato."
      );
    } else {
      this.loadingService.bloqueiaTela();
      this.tarefasContratoSccService
        .consultarMovimento(this.idSistema3, this.numeroContrato3)
        .subscribe((movis: Movi[]) => {
          if (movis == undefined || movis.length == 0) {
            this.messageService.addMessage({
              type: "CRUD_OPERATION",
              level: messageLevel.WARNING,
              message: "Não existe nenhum MOVI cadastrado no RCC para este contrato.",
            });
          } else {
            this.movisConsultados = movis;
          }
          this.loadingService.liberaTela();
        }, (error) => { this.loadingService.liberaTela(); });
    }
  }

  public excluirContrato() {
    if (this.idSistema1 == null || this.numeroContrato1 == null) {
      this.alertService.alertaErro(
        "Erro",
        "Para operação de exclusão, preencha os campos:  Sistema e Contrato."
      );
    } else {
      this.tarefasContratoSccService
        .excluirContrato(this.idSistema1, this.numeroContrato1)
        .subscribe(() => {
          this.messageService.addMessage({
            title: "Sucesso",
            type: "CRUD_OPERATION",
            level: messageLevel.SUCCESS,
            message: "Contrato removido com sucesso.",
          });
        });
    }
  }

  public excluirSimulacaoProCdd() {
    if (this.idSistema1 == null || this.numeroContrato1 == null) {
      this.alertService.alertaErro(
        "Erro",
        "Para operação de exclusão, preencha os campos:  Sistema e Contrato."
      );
    } else {
      this.loadingService.bloqueiaTela();
      this.tarefasContratoSccService
        .exluirProCdd(this.idSistema1, this.numeroContrato1)
        .subscribe(() => {
          this.messageService.addMessage({
            title: "Sucesso",
            type: "CRUD_OPERATION",
            level: messageLevel.SUCCESS,
            message: "Existencia de Pro-CDD para o contrato removida com sucesso.",
          });
          this.loadingService.liberaTela();
        }, (error) => { this.loadingService.liberaTela(); });
    }
  }

  public excluirSaldoDePrincipal() {
    if (this.idSistema2 == null || this.numeroContrato2 == null) {
      this.alertService.alertaErro(
        "Erro",
        "Para operação de exclusão, preencha os campos:  Sistema e Contrato."
      );
    } else {
      this.loadingService.bloqueiaTela();
      this.tarefasContratoSccService
        .excluirSaldoDePrincipal(this.idSistema2, this.numeroContrato2)
        .subscribe(() => {
          this.messageService.addMessage({
            title: "Sucesso",
            type: "CRUD_OPERATION",
            level: messageLevel.SUCCESS,
            message: "Saldo de principal removido com sucesso.",
          });
          this.loadingService.liberaTela();
        }, (error) => { this.loadingService.liberaTela(); });
    }
  }

  public excluirMovimento() {
    if (this.idSistema3 == null || this.numeroContrato3 == null) {
      this.alertService.alertaErro(
        "Erro",
        "Para operação de exclusão, preencha os campos:  Sistema e Contrato."
      );
    } else {
      this.loadingService.bloqueiaTela()
      this.tarefasContratoSccService
        .excluirMovimento(this.idSistema3, this.numeroContrato3)
        .subscribe(() => {
          this.messageService.addMessage({
            title: "Sucesso",
            type: "CRUD_OPERATION",
            level: messageLevel.SUCCESS,
            message: "MOVIs excluídos com sucesso.",
          });
          this.loadingService.liberaTela();
        }, (error) => { this.loadingService.liberaTela(); });
    }
  }

  public carregarRccFg2() {

      this.tarefasContratoSccService
        .carregarRccFg2()
        .subscribe(() => {
          this.messageService.addMessage({
            title: "Sucesso",
            type: "CRUD_OPERATION",
            level: messageLevel.SUCCESS,
            message: "Carga do RCC para a base do FG2 realizada com sucesso.",
          });
        });
  }

  public filtrarEventos(idSistema: number) {
    let idSistemaAsNumber = Number(idSistema);
    this.eventosFiltrados = this.eventosScc.filter(
      evento => (idSistema === undefined || evento.sistemas.indexOf(idSistemaAsNumber) > -1) &&
        (
          (evento.modalidade == undefined)
          || (evento.modalidade === this.siglaModalidade)
          || (this.siglaModalidade !== "PEAC" && evento.modalidade === "FG2")
        )
    );
  }

  onFileChange(event) {
    console.log("no on file change");

    const reader = new FileReader();

    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      reader.readAsText(file, "UTF-8");
      reader.onload = () => {
        if (typeof reader.result === 'string') {
          this.loteMovisCsv = reader.result;
        } else {
          this.loteMovisCsv = this.fileUtils.lerConteudo(reader);
        }

        console.log("conteudo arq lido front: " + this.loteMovisCsv);
        this.nomeLoteMovisCsv = file.name;
      };
    }
  }
  
  baixarCsvExemplo() {
    let conteudoArquivo = 
      'sistemaCobranca;contratoCobranca;ideEventoScc;valorEmUnidadeMonetaria;dataCompetencia;dataPagamento\n' + 
      '84;56240100005;920;1000.00;30/06/2022;30/06/2022'
      this.fileUtils.exportarArquivoUTF8('csv_exemplo.csv', conteudoArquivo, FileUtilsService.TEXT_CSV);
  }
}

